export const DUPLICATE_SURVEY = 'DUPLICATE_SURVEY';
